module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erco-text-area"
  }, [_c('label', {
    staticClass: "label_"
  }, [_c('span', {
    staticClass: "_text text-muted"
  }, [_vm._v(_vm._s(_vm.label || ' '))]), _vm._v(" "), _c('textarea', {
    staticClass: "textarea form-control",
    on: {
      "change": _vm.handleTextChange
    }
  }, [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00275da3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/ErcoTextArea.vue
// module id = 585
// module chunks = 0